import axios from 'axios';
import { getConfigProperty } from '@/common/oldMobile';
import { jwtTokenPromise } from 'nike-ui/src/common/axios/jwtTokenPromise';

if (!axios.__nike_setup) {
    throw Error('wrong axios create order');
}
const notificationClient = axios.create({
    baseURL: getConfigProperty('notifications.endpoint.url')
});
notificationClient.interceptors.response.use(response => response.data);
notificationClient.interceptors.request.use(config =>
    jwtTokenPromise().then(token => {
        if (window.USER_DATA_SNAPSHOT.cisloZmluvy) {
            config.headers['Authorization'] = `Bearer ${token}`;
            config.headers['Contract-Id'] = window.USER_DATA_SNAPSHOT.cisloZmluvy;
        }
        return config;
    })
);

export default notificationClient;
